import { render } from "./CatchOffers.vue?vue&type=template&id=36c8b624"
import script from "./CatchOffers.vue?vue&type=script&lang=js"
export * from "./CatchOffers.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__